var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "select",
        staticClass: "c-select",
        class: {
          "c-select_size_small": _vm.size === "small",
          invalid: _vm.invalid,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "c-select__wrapper",
            class: {
              "c-select__wrapper_with-label": _vm.label,
            },
          },
          [
            _vm.label
              ? _c("div", { staticClass: "c-select__label" }, [
                  _vm._v(" " + _vm._s(_vm.label) + " "),
                  _vm.requiredMark
                    ? _c("span", { staticClass: "c-select__label__required" }, [
                        _vm._v("*"),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.floatingLabel
              ? _c(
                  "div",
                  { staticClass: "c-select-floating-label-not-visible" },
                  [_vm._v(" " + _vm._s(_vm.floatingLabel) + " ")]
                )
              : _vm._e(),
            _vm.floatingLabel
              ? _c(
                  "div",
                  {
                    staticClass: "c-select-floating-label",
                    class: {
                      "c-select-floating-label-active":
                        (_vm.isArray(_vm.localValue) &&
                          _vm.localValue.length !== 0) ||
                        (!_vm.isArray(_vm.localValue) && _vm.localValue),
                    },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
                    _vm.requiredMark
                      ? _c(
                          "span",
                          { staticClass: "c-select__label__required" },
                          [_vm._v("*")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                ref: "input",
                staticClass: "c-select__input",
                class: {
                  "c-select__input_empty":
                    _vm.multiple &&
                    (!_vm.localValue || _vm.localValue.length === 0),
                  "c-select__input_required": !_vm.multiple && _vm.required,
                },
                attrs: { type: "button" },
              },
              [
                !_vm.multiple
                  ? _c(
                      "div",
                      {
                        staticClass: "c-select__value",
                        on: { click: _vm.openContainer },
                      },
                      [
                        _vm.localValue
                          ? [
                              _vm.localValue.resultLabel
                                ? [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.localValue.resultLabel
                                        ),
                                      },
                                    }),
                                  ]
                                : [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.localValue.label ||
                                            _vm.getLabel(_vm.localValue)
                                        )
                                      ),
                                    ]),
                                  ],
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.multiple
                  ? _c(
                      "div",
                      {
                        staticClass: "c-select__value c-select__value_multiple",
                        on: { click: _vm.openContainer },
                      },
                      _vm._l(_vm.localValue, function (valueItem) {
                        return _c(
                          "div",
                          {
                            key: valueItem.value,
                            staticClass: "c-select__value-item",
                            style: {
                              backgroundColor:
                                _vm.useCustomColors && valueItem.backgroundColor
                                  ? valueItem.backgroundColor
                                  : "#fff",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-select__value-item-label" },
                              [
                                valueItem.resultLabel
                                  ? [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            valueItem.resultLabel
                                          ),
                                        },
                                      }),
                                    ]
                                  : [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.localValue.label ||
                                              _vm.getLabel(valueItem)
                                          )
                                        ),
                                      ]),
                                    ],
                              ],
                              2
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "c-select__value-item-close",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.dropItem(valueItem)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "12",
                                      height: "12",
                                      viewBox: "0 0 13 13",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.placeholder &&
                (!_vm.localValue || _vm.localValue.length === 0)
                  ? _c("div", { staticClass: "c-select__placeholder" }, [
                      _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                    ])
                  : _vm._e(),
                _vm.clearable
                  ? _c(
                      "div",
                      {
                        staticClass: "c-select__clear",
                        class: { "c-select__clear_hidden": !_vm.localValue },
                        on: { click: _vm.clear },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 13 13",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.checkbox
                  ? _c(
                      "div",
                      {
                        staticClass: "c-select__icon",
                        on: { click: _vm.openContainer },
                      },
                      [_c("c-icon", { attrs: { icon: "arrow" } })],
                      1
                    )
                  : _vm._e(),
                _vm.reverse !== undefined
                  ? _c(
                      "div",
                      { staticClass: "c-select__reverse" },
                      [
                        !_vm.reverseType
                          ? _c("c-switcher", {
                              staticClass: "c-select__reverse-switcher",
                              attrs: {
                                disabled: !_vm.value || _vm.value.length === 0,
                                label: "Все кроме",
                                type: "checkbox",
                              },
                              on: { mousedown: _vm.mousedownReverse },
                              model: {
                                value: _vm.localReverse,
                                callback: function ($$v) {
                                  _vm.localReverse = $$v
                                },
                                expression: "localReverse",
                              },
                            })
                          : _vm._e(),
                        _vm.reverseType === "icon"
                          ? _c("c-switcher", {
                              attrs: {
                                type: "checkbox-icon",
                                disabled:
                                  !_vm.localValue ||
                                  (_vm.localValue &&
                                    _vm.localValue.length === 0),
                                tooltip: _vm.reverseTooltip,
                              },
                              on: { mousedown: _vm.mousedownReverse },
                              model: {
                                value: _vm.localReverse,
                                callback: function ($$v) {
                                  _vm.localReverse = $$v
                                },
                                expression: "localReverse",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.checkbox
                  ? _c(
                      "div",
                      {
                        staticClass: "c-select-checkbox",
                        class: {
                          "c-select-checkbox-type-icon":
                            _vm.checkboxType === "icon",
                        },
                      },
                      [
                        _vm.checkboxType === "icon"
                          ? _c("c-switcher", {
                              attrs: {
                                type: "checkbox-icon",
                                disabled: !_vm.value || _vm.value.length === 0,
                                tooltip: _vm.checkboxTooltip,
                              },
                              model: {
                                value: _vm.checkboxValueLocal,
                                callback: function ($$v) {
                                  _vm.checkboxValueLocal = $$v
                                },
                                expression: "checkboxValueLocal",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm.required && !_vm.multiple
              ? _c(
                  "div",
                  { staticClass: "c-select-required c-select-required_active" },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "7",
                            cy: "7",
                            r: "6.5",
                            fill: "white",
                            stroke: "#FF238D",
                          },
                        }),
                        _c("circle", {
                          attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "6",
                            y: "3",
                            width: "2",
                            height: "5",
                            rx: "1",
                            fill: "#FF238D",
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "c-select-required-text" }, [
                      _vm._v(_vm._s(_vm.required)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.items
              ? _c(
                  "div",
                  {
                    ref: "container",
                    staticClass: "c-select__container",
                    class: { "c-select__container_active": _vm.container },
                  },
                  [
                    _vm.showSearch
                      ? _c(
                          "div",
                          { staticClass: "c-select__search" },
                          [
                            _c(
                              "div",
                              { staticClass: "c-select__search-icon" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "13",
                                      height: "13",
                                      viewBox: "0 0 17 17",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.query,
                                  expression: "query",
                                },
                              ],
                              ref: "searchInput",
                              staticClass: "c-select__search-input",
                              attrs: { type: "text", placeholder: "Поиск" },
                              domProps: { value: _vm.query },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.query = $event.target.value
                                },
                              },
                            }),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _vm.query
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "c-select__search-clear",
                                      on: { click: _vm.resetSearch },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 12 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                                              fill: "#FF238D",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                                              fill: "#FF238D",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { ref: "list", staticClass: "c-select__list" },
                      [
                        !_vm.filteredGroups.length
                          ? _c("div", [
                              _c("div", { staticClass: "c-select__empty" }, [
                                _vm._v(" " + _vm._s(_vm.emptyMessage) + " "),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.filteredGroups, function (group) {
                          return _c(
                            "div",
                            {
                              key: group.id,
                              staticClass: "c-select__group",
                              attrs: { "data-group": group.id },
                            },
                            [
                              group.label
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "c-select__group-label",
                                      style: {
                                        color:
                                          _vm.useCustomColors && group.color
                                            ? group.color
                                            : "",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(group.label),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "c-select__group-items" },
                                _vm._l(group.items, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.value,
                                      staticClass: "c-select__item",
                                      class: {
                                        "c-select__item_selected":
                                          _vm.isItemSelected(item),
                                        "c-select__item_disabled":
                                          _vm.isItemDisabled(item),
                                      },
                                      on: {
                                        click: (e) => _vm.selectItem(item),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "c-select__item-label" },
                                        [
                                          item.formatLabel
                                            ? [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      item.formatLabel
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.label ||
                                                        _vm.getLabel(item)
                                                    )
                                                  ),
                                                ]),
                                              ],
                                          item.subLabel
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-select__item-sublabel",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.subLabel) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm.multiple
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-select__group-items-mobile",
                                    },
                                    _vm._l(group.items, function (item) {
                                      return _c("c-switcher", {
                                        key: `switcher-item-${item.value}`,
                                        staticClass: "c-select__item__mobile",
                                        attrs: {
                                          id: item.value,
                                          label: {
                                            text:
                                              item.formatLabel || item.label,
                                            color: null,
                                          },
                                          type: "checkbox",
                                          value: item,
                                          checked: item,
                                          multi: true,
                                          nowrap: true,
                                        },
                                        model: {
                                          value:
                                            _vm.checkedMobileMultipleSelects,
                                          callback: function ($$v) {
                                            _vm.checkedMobileMultipleSelects =
                                              $$v
                                          },
                                          expression:
                                            "checkedMobileMultipleSelects",
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-select__group-items-mobile",
                                    },
                                    _vm._l(group.items, function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.value,
                                          staticClass: "c-select__item",
                                          class: {
                                            "c-select__item_selected":
                                              _vm.isItemSelected(item),
                                            "c-select__item_disabled":
                                              _vm.isItemDisabled(item),
                                          },
                                          on: {
                                            click: (e) => _vm.selectItem(item),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-select__item-label",
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.label) + " "
                                              ),
                                              item.subLabel
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-select__item-sublabel",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.subLabel
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "c-select__list__buttons" },
                      [
                        _c("c-button", {
                          staticClass: "c-select__list__buttons-cancel",
                          attrs: { size: "small", label: "Отмена" },
                          on: { click: _vm.closeContainer },
                        }),
                        _vm.multiple
                          ? _c("c-button", {
                              attrs: {
                                size: "small",
                                label: "Готово",
                                color: "primary",
                              },
                              on: { click: _vm.selectMobileItems },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm.error
          ? _c("error-feedback", { attrs: { text: _vm.error } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }